import { useEffect, useRef, useState, useCallback } from "react";
export var KEYS = {
    tab: 9,
    enter: 13,
    escape: 27,
    keyDown: 40,
    keyUp: 38,
};
var useKeyBoard = function (_a) {
    var updateFocus = _a.updateFocus;
    var refs = useRef([]);
    var _b = useState(-1), selectionIndex = _b[0], setSelectionIndex = _b[1];
    var createKeyPressHandler = useCallback(function (actions) { return function (e) {
        switch (e.keyCode) {
            case KEYS.enter:
                setSelectionIndex(-1);
                break;
            case KEYS.tab:
                if (e.shiftKey) {
                    if (selectionIndex >= 0) {
                        setSelectionIndex(selectionIndex - 1);
                        if (actions.up)
                            actions.up();
                    }
                }
                else if (selectionIndex < refs.current.length - 1) {
                    setSelectionIndex(selectionIndex + 1);
                    if (actions.down)
                        actions.down();
                }
                break;
            case KEYS.keyUp:
                if (selectionIndex >= 0) {
                    setSelectionIndex(selectionIndex - 1);
                    if (actions.up)
                        actions.up();
                }
                break;
            case KEYS.keyDown:
                if (selectionIndex < refs.current.length - 1) {
                    setSelectionIndex(selectionIndex + 1);
                    if (actions.down)
                        actions.down();
                }
                break;
            case KEYS.escape:
                if (actions.escape)
                    actions.escape();
                break;
        }
    }; }, [refs, selectionIndex]);
    // set focus on input or result item
    useEffect(function () {
        var ref = refs.current[selectionIndex];
        if (ref && selectionIndex !== -1)
            ref.focus(); // when index -1, the element is autofocused on pageload
    }, [selectionIndex]);
    // set focus on input when search is opened.
    useEffect(function () {
        if (updateFocus) {
            var ref = refs.current[-1];
            if (ref)
                ref.focus();
        }
    }, [updateFocus]);
    return {
        refs: refs,
        createKeyPressHandler: createKeyPressHandler,
        selectionIndex: selectionIndex,
        setSelectionIndex: setSelectionIndex,
    };
};
export default useKeyBoard;
